class MemoryLogger {
    constructor(maxLogs = 1000) {
        this.logs = [];
        this.maxLogs = maxLogs;
    }

    log(...args) {
        const entry = {
            timestamp: new Date().toISOString(),
            args,
        };
        this.logs.push(entry);
        if (this.logs.length > this.maxLogs) {
            this.logs.shift();
        }
    }

    getLogs() {
        return [ ...this.logs ];
    }

    clear() {
        this.logs = [];
    }

    truncateLargeFields(obj, forbiddenKeys = []) {
        return truncateLargeFields(obj, forbiddenKeys);
    }

    safeSlice(str, start, end) {
        return safeSlice(str, start, end);
    }

    async sendToTelegram(forbiddenKeys = [ 'visits' ], filter) {
        const logs = this.getLogs();
        return sendToTelegram(logs, forbiddenKeys, filter);
    }
}

// Вспомогательные функции для работы с данными
function truncateLargeFields(obj, forbiddenKeys = []) {
    if (obj === null || obj === undefined) {
        return obj;
    }
    if (typeof obj === 'string') {
        if (obj.length > 300) {
            return `Data ${obj.length} bytes`;
        }
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map((item) => truncateLargeFields(item, forbiddenKeys));
    }
    if (typeof obj === 'object') {
        const newObj = {};
        for (const key in obj) {
            if (!Object.prototype.hasOwnProperty.call(obj, key)) {
                continue;
            }
            if (forbiddenKeys.includes(key)) {
                newObj[key] = '[HIDDEN]';
                continue;
            }
            const value = obj[key];
            if (typeof value === 'string' && value.length > 300) {
                newObj[key] = `Data ${value.length} bytes`;
            } else if (typeof value === 'object' && value !== null) {
                newObj[key] = truncateLargeFields(value, forbiddenKeys);
            } else {
                newObj[key] = value;
            }
        }
        return newObj;
    }
    return obj;
}

function safeSlice(str, start, end) {
    let s = start;
    let e = end;
    while (s > 0 && /[\uDC00-\uDFFF]/.test(str[s])) {
        s--;
    }
    while (e < str.length && /[\uDC00-\uDFFF]/.test(str[e])) {
        e++;
    }
    return str.slice(s, e);
}

// Основная функция для отправки данных в Telegram
export async function sendToTelegram(data, forbiddenKeys = [ 'visits' ], filter) {
    try {


        const chatIds = Object.telegramDevLogUsers;
        const url = `https://api.telegram.org/bot${Object.telegramDevLogBot}/sendMessage`;

        let safeData1 = truncateLargeFields(data, forbiddenKeys);
        let safeData = safeData1;
        if (filter) {
            safeData = filterObject(safeData1, filter);
            console.log('FILTER, ', {
                safeData,
                safeData1,
            });
        }
        const message = JSON.stringify(safeData, null, 2);
        const maxLength = 4000;
        const parts = [];

        for (let i = 0; i < message.length; i += maxLength) {
            parts.push(safeSlice(message, i, i + maxLength));
        }

        if (Array.isArray(chatIds)) {
            for (const chatId of chatIds) {
                for (let idx = 0; idx < parts.length; idx++) {
                    const body = {
                        chat_id: chatId,
                        text: parts.length > 1 ? `Part ${idx + 1}/${parts.length}:\n${parts[idx]}` : parts[idx],
                    };
                    const resp = await fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(body),
                    });
                    if (!resp.ok) {
                        const errText = await resp.text();
                        console.error('sendToTelegram error', {
                            status: resp.status,
                            errText,
                            part: idx + 1,
                        });
                    }
                }
            }
        } else if (chatIds) {
            for (let idx = 0; idx < parts.length; idx++) {
                const body = {
                    chat_id: chatIds,
                    text: parts.length > 1 ? `Part ${idx + 1}/${parts.length}:\n${parts[idx]}` : parts[idx],
                };
                const resp = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(body),
                });
                if (!resp.ok) {
                    const errText = await resp.text();
                    console.error('sendToTelegram error', {
                        status: resp.status,
                        errText,
                        part: idx + 1,
                    });
                }
            }
        }
    } catch (error) {
        console.error('sendToTelegram error', error);
    }
}

export const filterObject = (obj, filterStr = '') => {
    if (!obj || typeof obj !== 'object') {
        return {};
    }
    if (!filterStr) {
        return obj;
    }
    const filterLower = filterStr.toLowerCase()
        .trim();
    const result = {};
    Object.keys(obj)
        .forEach(key => {
            const keyLower = key.toLowerCase();
            if (keyLower.includes(filterLower)) {
                result[key] = obj[key];
            }
        });
    return result;
};

export const filterLog = (logObj, filterStr = '') => {
    return filterObject(logObj, filterStr);
};

export const logger = new MemoryLogger();

export default logger;
